let xml2JsonRecursive = function(node, idx, parent) {
  if (node.nodeName == "#text") return;
  var key = node.tagName; //+(j++);
  var child = node.childNodes;

  if (key in parent) key += Object.keys(parent).length.toString();

  if (node.childElementCount == 0) {
    parent[key] = node.textContent;
    return;
  }

  parent[key] = {};
  for (var i = 0; i < child.length; i++) {
    xml2JsonRecursive(child[i], idx + 1, parent[key]);
  }
};

let Xml2Json = function(xmlDoc) {
  //Tyically for an array item, a name that distinguish it with others will be assigned, so that we don't need to care the name of the XML element, just assign a number to the XML element is enough.
  if (typeof xmlDoc == "string") {
    /*var tmpContainer=create("DIV",{
							innerHTML: xmlDoc
					});
					xmlDoc=tmpContainer.childNodes.item(0);*/
    var parser = new DOMParser();
    xmlDoc = parser.parseFromString(xmlDoc, "text/xml");
  }
  var output = {};
  xml2JsonRecursive(xmlDoc.childNodes[0], 0, output);
  return output;
};

export default Xml2Json;
